import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=53ae10a0&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports